// DON't CHANGE!
// automated by SVGR script
import * as React from "react";
const TicketIcon = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  "data-icon": "Ticket/outline"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M21 10v1a1 1 0 0 0 1-1h-1Zm0 4h1a1 1 0 0 0-1-1v1ZM3 14v-1a1 1 0 0 0-1 1h1Zm0-4H2a1 1 0 0 0 1 1v-1Zm2-6a3 3 0 0 0-3 3h2a1 1 0 0 1 1-1V4Zm14 0H5v2h14V4Zm3 3a3 3 0 0 0-3-3v2a1 1 0 0 1 1 1h2Zm0 3V7h-2v3h2Zm-2 2a1 1 0 0 1 1-1V9a3 3 0 0 0-3 3h2Zm1 1a1 1 0 0 1-1-1h-2a3 3 0 0 0 3 3v-2Zm1 4v-3h-2v3h2Zm-3 3a3 3 0 0 0 3-3h-2a1 1 0 0 1-1 1v2ZM5 20h14v-2H5v2Zm-3-3a3 3 0 0 0 3 3v-2a1 1 0 0 1-1-1H2Zm0-3v3h2v-3H2Zm2-2a1 1 0 0 1-1 1v2a3 3 0 0 0 3-3H4Zm-1-1a1 1 0 0 1 1 1h2a3 3 0 0 0-3-3v2ZM2 7v3h2V7H2Z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M15 5v2"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M15 11v2M15 17v2"
}));
export default TicketIcon;